export default "/assets/user_zendesk_dark-7e609dfbc6bcbd68bfb00d0fdd457d9157c81b58c706890beb2343fd2b8f9c33.svg";